import React from "react"
import { TooltipWithBounds, defaultStyles } from "@visx/tooltip"

const FROSTED_GLASS_STYLE = {
    ...defaultStyles,
    backgroundColor: "rgba(18, 20, 24, 0.72)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    borderRadius: "12px",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.6)",
    color: "white",
    padding: "10px 14px",
} as const

type FrostedGlassTooltipProps = {
    top: number
    left: number
    children: React.ReactNode
}

export const FrostedGlassTooltip = ({ top, left, children }: FrostedGlassTooltipProps) => (
    <TooltipWithBounds top={top - 10} left={left + 10} style={FROSTED_GLASS_STYLE}>
        {children}
    </TooltipWithBounds>
)
